import { useEffect } from "react";

export default function useGlobalPanels(visible: boolean): void
{
    useEffect(() =>
    {
        if (!visible)
            document.body.classList.add("hideGlobalPanels");
        else
            document.body.classList.remove("hideGlobalPanels");

        return () =>
        {
            if (!visible)
                document.body.classList.remove("hideGlobalPanels");
            else
                document.body.classList.add("hideGlobalPanels");
        };
    }, [visible]);
}